import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { GridLegacy, Typography } from "@mui/material";

import { talenV5 } from "../../../variables/app";
import FormTextTC from "../../../components/Forms/FormTextTC";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";

function Translations() {
  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <GridLegacy container spacing={1}>
        <GridLegacy item lg={4} xs={12}>
          <Card>
            <CardBody style={{ padding: 16 }}>
              <GridLegacy container spacing={1}>
                <GridLegacy item xs={12}>
                  <Typography component={"h3"}>
                    <TranslationWrapper tDefault={"Vertaling naam"} tKey={"producten.form.tabs.vertalingNaam"} />
                  </Typography>
                </GridLegacy>
                {Object.keys(talenV5).map((objKey) => {
                  let taal = talenV5[objKey];

                  return (
                    <FormTextTC
                      key={objKey}
                      label={<TranslationWrapper tDefault={taal.label} tKey={"global." + taal.transKey} />}
                      name={"translations." + objKey + ".naam"}
                    />
                  );
                })}
              </GridLegacy>
            </CardBody>
          </Card>
        </GridLegacy>
        <GridLegacy item lg={4} xs={12}>
          <Card>
            <CardBody style={{ padding: 16 }}>
              <GridLegacy container spacing={1}>
                <GridLegacy item xs={12}>
                  <Typography component={"h3"}>
                    <TranslationWrapper
                      tDefault={"Vertaling omschrijving"}
                      tKey={"producten.form.tabs.vertalingOmschrijving"}
                    />
                  </Typography>
                </GridLegacy>
                {Object.keys(talenV5).map((objKey) => {
                  let taal = talenV5[objKey];

                  return (
                    <FormTextTC
                      key={objKey}
                      label={<TranslationWrapper tDefault={taal.label} tKey={"global." + taal.transKey} />}
                      name={"translations." + objKey + ".bigdescr"}
                      rows={3}
                    />
                  );
                })}
              </GridLegacy>
            </CardBody>
          </Card>
        </GridLegacy>
        <GridLegacy item lg={4} xs={12}>
          <Card>
            <CardBody style={{ padding: 16 }}>
              <GridLegacy container spacing={1}>
                <GridLegacy item xs={12}>
                  <Typography component={"h3"}>
                    <TranslationWrapper
                      tDefault={"Translation Category"}
                      tKey={"producten.form.tabs.vertalingCategorie"}
                    />
                  </Typography>
                </GridLegacy>
                {Object.keys(talenV5).map((objKey) => {
                  let taal = talenV5[objKey];

                  return (
                    <FormTextTC
                      key={objKey}
                      label={<TranslationWrapper tDefault={taal.label} tKey={"global." + taal.transKey} />}
                      name={"translations." + objKey + ".categorie"}
                    />
                  );
                })}
              </GridLegacy>
            </CardBody>
          </Card>
        </GridLegacy>
      </GridLegacy>
    </div>
  );
}

export default Translations;
